




































































import Vue from "vue";

import { GenerateForgotPasswordTokenCommand } from "@/model/communication/auth/GenerateForgotPasswordTokenCommand";
import { formatSeconds } from "@/utility/Formatter";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";

export default Vue.extend({
    props: {
        showForgotPassword: Boolean,
    },
    data() {
        return {
            forgotPasswordUsername: "",
            showAlertForgotPassword: false,
            loadingGenerateForgotPasswordToken: false,
            timeRemaining: 0,
            showAlertForgotPasswordType: "",
            showAlertForgotPasswordMessage: "",
        };
    },
    computed: {
        showForgotPasswordVal: {
            get() {
                return this.showForgotPassword;
            },
            set(val: boolean) {
                this.$emit("update:showForgotPassword", val);
            },
        },
    },
    methods: {
        formatSeconds,
        async generateForgotPasswordToken() {
            this.loadingGenerateForgotPasswordToken = true;
            try {
                var res = await new GenerateForgotPasswordTokenCommand(this.forgotPasswordUsername).execute();

                if (res.responseStatus == ApiResponseStatusEnum.Success && res.responseString != "GenericError") {
                    this.showAlertForgotPassword = true;
                    this.showAlertForgotPasswordType = "success";
                    this.showAlertForgotPasswordMessage = this.$t("login.forgotPasswordEmailSent");
                    this.startTimer();
                } else {
                    this.showAlertForgotPasswordMessage = this.$t("login.waitTwoMinutes");
                    this.showAlertForgotPassword = true;
                    this.showAlertForgotPasswordType = "error";
                    this.startTimer();
                }
            } catch (exc) {
                console.error("Something went wrong while sending GenerateForgotPasswordToken request");
                this.showAlertForgotPassword = true;
                this.showAlertForgotPasswordMessage = this.$t("login.genericErrorResetPassword");
                this.showAlertForgotPasswordType = true;
            }

            this.loadingGenerateForgotPasswordToken = false;
        },
        startTimer() {
            let timeout = 2 * 60;
            this.timeRemaining = timeout;
            const self = this;
            let countdownTimerInternal = setInterval(function () {
                if (self.timeRemaining > 0) {
                    self.timeRemaining--;
                } else {
                    clearInterval(countdownTimerInternal);
                }
            }, 1000);
        },
    },
});
